module.exports = __webpack_public_path__ + "img/Solana.f8aaba82.svg";